import axios from 'axios';
import { IOrderDetail } from '../model/order/order-detail.model';

const baseUrl = 'api/public';

export default class ReportService {
  public paypal(orderDetail: IOrderDetail): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseUrl}/paypal/pay`, orderDetail)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public checkPaidOrder(orderNumberEnc: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseUrl}/payment/stripe/check-payment/${orderNumberEnc}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public validateStripePayment(sessionId: string): Promise<IOrderDetail> {
    return new Promise<IOrderDetail>((resolve, reject) => {
      axios
        .get(`${baseUrl}/payment/stripe/validate-payment?sessionId=${sessionId}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public stripe(paymentTypeValue: string, orderDetail: IOrderDetail): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseUrl}/stripe/pay/${paymentTypeValue}`, orderDetail)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public cash(orderDetail: IOrderDetail): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseUrl}/cash/pay`, orderDetail)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
